module.exports = "<div ng-repeat=\"(proyecto, finiquitos) in $ctrl.data track by proyecto\">\r\n  <div class=\"kd-item padding-md margin-sm\">\r\n    <div class=\"--text-bold text-light flex\">{{::proyecto}}</div>\r\n  </div>\r\n  <nominas-finiquitos-pendientes-item\r\n      ng-repeat=\"item in finiquitos track by item.indice\"\r\n      data=\"item\"\r\n      on-delete=\"$ctrl.eliminar($event.data)\"></nominas-finiquitos-pendientes-item>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/nominas/finiquitos/components/pendientes/grupo/template.html
// module id = 1015
// module chunks = 0